module.exports = __webpack_public_path__ + "img/jordan.c8cfe14d.svg";